// 定义后端访问地址
// const backendUrls = {
//   url: 'http://localhost:19000',
//   wsUrl: 'ws://localhost:19000',
//   baseUrl: 'localhost:19000',
//   urlName: '-qxBase博客'
// };
const backendUrls = {
  // Keep API calls on the public site's origin. Nginx proxies /api to the
  // application, avoiding a separate DNS/CORS dependency for the frontend.
  url: '/api',
  wsUrl: 'wss://blog.qxbase.com/api',
  baseUrl: 'blog.qxbase.com',
  urlName: '-qxBase博客'
};
// const backendUrls = {
//   url: 'http://localhost:8080',
//   wsUrl: 'ws://localhost:8080',
//   baseUrl: 'localhost:8080',
//   urlName: '-qxBase博客'
// };

// 导出后端访问地址
export default backendUrls;
